// script.js (plane index.html) ~sdg
'use strict'
console.time('LoadTime')

import './normalize.css'
import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { MeshBasicMaterial } from 'three'

/**
 * Base
 */
// Debug
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const group = new THREE.Group()
scene.add(group)

/**
 * Axes Helper
 */
//const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)

/*
 * Objects
 */
// Geometries
const planeGeometry = new THREE.PlaneGeometry()

// Textures & Materials
const textureLoader = new THREE.TextureLoader()
const flowerTexture = textureLoader.load('./textures/flower.jpg')

const flowerMaterial = new MeshBasicMaterial({ map: flowerTexture })
flowerMaterial.side = THREE.DoubleSide

const blueMaterial = new THREE.MeshBasicMaterial({ color: 0x0000ff })
blueMaterial.side = THREE.DoubleSide

// Planes
const redPlane = new THREE.Mesh(planeGeometry, flowerMaterial)

const greenPlane = new THREE.Mesh(planeGeometry, flowerMaterial)
greenPlane.rotation.y = Math.PI * 0.5

const bluePlane = new THREE.Mesh(planeGeometry, blueMaterial)
bluePlane.scale.set(0.75, 0.75)
bluePlane.rotation.x = Math.PI * 0.5

group.rotation.x = Math.PI * 0.2
group.rotation.z = Math.PI * 0.15
group.add(redPlane, greenPlane, bluePlane)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 2.5
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  controls.update()

  // Update objects
  group.rotation.y = elapsedTime

  // Render
  renderer.render(scene, camera)

  // Call animate again on next frame
  window.requestAnimationFrame(animate)
}

animate()
console.timeEnd('LoadTime')
// EOF script.js (plane index.html) ~sdg